import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import ChildNavItem from './ChildNavItem';
import Pill from './Pill';
import Popover from './Popover';
import Paragraph from './renderers/Paragraph';
import CardLink from './CardLink';

const ResourcePopoverNav = ({ items, ...props }) => {
  const {
    resources: {
      nodes: [resource],
    },
  } = useStaticQuery(graphql`
    {
      resources: allGraphCmsResource(
        filter: { featured: { eq: true } }
        limit: 1
      ) {
        nodes {
          coverImage {
            localFile {
              childImageSharp {
                fluid(maxWidth: 480) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
          externalUrl
          linkPath
          slug
          subTitle
          title
          truncatedSubTitle
          type
        }
      }
    }
  `);

  if (items.length <= 0) return null;

  return (
    <Popover {...props} grow>
      <div className="flex">
        <div>
          {items.map((item, index) => (
            <ChildNavItem key={index} {...item} widen />
          ))}
        </div>
        {resource && (
          <CardLink
            externalUrl={resource.externalUrl}
            linkPath={resource.linkPath}
            className="-my-2 hidden lg:block"
          >
            <div className="flex flex-col bg-whisper w-84">
              <div className="flex flex-col pr-6 pl-8 order-2">
                <div className="flex flex-row items-baseline mt-6 mb-0">
                  <h5 className="font-bold">{resource.title}</h5>
                  <Pill label={resource.type} colour="pink" size="small" />
                </div>
                <Paragraph size="small" className="flex-grow lg:mb-6">
                  {resource.truncatedSubTitle}
                </Paragraph>
              </div>
              {resource.coverImage && (
                <Img
                  fluid={resource.coverImage.localFile.childImageSharp.fluid}
                  title={resource.title}
                  alt={resource.title}
                  fadeIn={true}
                  className="order-1"
                />
              )}
            </div>
          </CardLink>
        )}
      </div>
    </Popover>
  );
};

export default ResourcePopoverNav;
